/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * てのひら眼科 Patient API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import {
  useCallback
} from 'react'
import type {
  BadRequestResponse,
  CompletePayment200,
  CompletePaymentBodies,
  ForbiddenResponse,
  InternalServerErrorResponse,
  ListPendingPayments200,
  NotFoundResponse,
  UnauthorizedResponse
} from '.././model'
import { useAPIPatientClient } from '../../apiPatientConfig';
import type { ErrorType, BodyType } from '../../apiPatientConfig';



/**
 * ログイン中の患者に紐づく Order のうち、status=pendingAuthentication のものを返す。患者アプリの「未完了のお支払い」画面で利用する。
 * @summary 3DS 認証待ち決済一覧の取得
 */
export const useListPendingPaymentsHook = () => {
        const listPendingPayments = useAPIPatientClient<ListPendingPayments200>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return listPendingPayments(
          {url: `/patient/api/patient/pending-payments`, method: 'GET', signal
    },
          );
        }, [listPendingPayments])
      }
    

export const getListPendingPaymentsQueryKey = () => {
    return [`/patient/api/patient/pending-payments`] as const;
    }

    
export const useListPendingPaymentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>, TError = ErrorType<UnauthorizedResponse | InternalServerErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPendingPaymentsQueryKey();

  const listPendingPayments =  useListPendingPaymentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>> = ({ signal }) => listPendingPayments(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPendingPaymentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>>
export type ListPendingPaymentsQueryError = ErrorType<UnauthorizedResponse | InternalServerErrorResponse>

/**
 * @summary 3DS 認証待ち決済一覧の取得
 */
export const useListPendingPayments = <TData = Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>, TError = ErrorType<UnauthorizedResponse | InternalServerErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPendingPaymentsHook>>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = useListPendingPaymentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 患者アプリ側で Stripe.js handleCardAction が完了した際に呼び出す。バックエンドが PaymentIntent のステータスを Stripe から取得し、succeeded であれば Order を done に更新する。
 * @summary 3DS 認証完了の通知
 */
export const useCompletePaymentHook = () => {
        const completePayment = useAPIPatientClient<CompletePayment200>();

        return useCallback((
    completePaymentBodies: BodyType<CompletePaymentBodies>,
 ) => {
        return completePayment(
          {url: `/patient/api/patient/complete-payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completePaymentBodies
    },
          );
        }, [completePayment])
      }
    


export const useCompletePaymentMutationOptions = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>, TError,{data: BodyType<CompletePaymentBodies>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>, TError,{data: BodyType<CompletePaymentBodies>}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      const completePayment =  useCompletePaymentHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>, {data: BodyType<CompletePaymentBodies>}> = (props) => {
          const {data} = props ?? {};

          return  completePayment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompletePaymentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>>
    export type CompletePaymentMutationBody = BodyType<CompletePaymentBodies>
    export type CompletePaymentMutationError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>

    /**
 * @summary 3DS 認証完了の通知
 */
export const useCompletePayment = <TError = ErrorType<BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>, TError,{data: BodyType<CompletePaymentBodies>}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCompletePaymentHook>>>,
        TError,
        {data: BodyType<CompletePaymentBodies>},
        TContext
      > => {

      const mutationOptions = useCompletePaymentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    